import React from "react";

export default function LoadingContent() {
  return <div>Loading...</div>;
}
